export default __webpack_public_path__ + "static/media/news-default-3.12dd6400.png";